@if (showTable && !accessDenied) {
  <div class="lt-container">
    <div class="lt-toolbar">
      <div class="lt-toolbar-left">
        @if (toolbarControls.search.show) {
          <div class="lt-search" [class.lt-ctl-disabled]="toolbarControls.search.disabled">
            <svg class="lt-search-icon" viewBox="0 0 16 16" width="14" height="14" aria-hidden="true">
              <circle cx="7" cy="7" r="4.3" fill="none" stroke="currentColor" stroke-width="1.5"/>
              <line x1="10.4" y1="10.4" x2="14.6" y2="14.6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
            <input
              class="lt-search-input"
              id="SearchFilter"
              type="text"
              [placeholder]="'Search ' + (entityTypeLabel || 'items')"
              [(ngModel)]="searchString"
              [disabled]="toolbarControls.search.disabled"
              (keyup)="onSearchInput()"
            />
          </div>
        }
        @if (toolbarControls.filters.show && filterableColumns.length) {
          <div class="lt-filter-zone" [class.lt-ctl-disabled]="toolbarControls.filters.disabled" #filterZone>
            <div class="lt-filters" #filtersRow>
              @for (col of visibleFilterColumns; track col.key) {
                <span class="lt-filter-item" [attr.data-filter-key]="col.key">
                  <lib-list-filter-cell [column]="col"></lib-list-filter-cell>
                </span>
              }
            </div>
            @if (overflowFilterColumns.length) {
              <div class="lt-filter-more">
                <button
                  type="button"
                  class="lt-filter-more-btn"
                  [class.is-on]="hiddenActiveCount > 0"
                  [class.is-open]="showFilterOverflow"
                  (click)="toggleFilterOverflow($event)"
                  aria-haspopup="true"
                  [attr.aria-expanded]="showFilterOverflow"
                  [attr.aria-label]="overflowFilterColumns.length + ' more filters'"
                  id="FilterOverflowButton"
                >
                  <span class="lt-filter-more-icon" aria-hidden="true">
                    <svg viewBox="0 0 16 16" width="14" height="14"><path fill="currentColor" d="M2 3h12l-4.6 5.6v4l-2.8 1.4v-5.4z"/></svg>
                  </span>
                  <span class="lt-filter-more-label">More</span>
                  <span class="lt-filter-more-count">{{ overflowFilterColumns.length }}</span>
                </button>
                @if (showFilterOverflow) {
                  <div class="lt-filter-overflow" (clickOutside)="closeFilterOverflow($event)">
                    <div class="lt-filter-overflow-title">Filters</div>
                    @for (col of overflowFilterColumns; track col.key) {
                      <div class="lt-filter-overflow-row" [class.is-active]="isFilterActive(col)">
                        <lib-list-filter-cell [column]="col"></lib-list-filter-cell>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }
        <!-- Consumer-supplied toolbar controls (e.g. page-specific filters), rendered inline beside search. -->
        <ng-content select="[toolbar-filters]"></ng-content>
      </div>
      <div class="lt-toolbar-right">
        <ng-template #refreshIcon>
          <svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true">
            <path fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" d="M13.4 8a5.4 5.4 0 1 1-1.5-3.8"/>
            <path fill="currentColor" d="M13.9 2.1l.5 3.2-3.2-.5z"/>
          </svg>
        </ng-template>
        @if (toolbarControls.refresh.show) {
          <button
            type="button"
            class="lt-refresh-btn"
            (click)="refresh()"
            [disabled]="filtering || toolbarControls.refresh.disabled"
            aria-label="Refresh"
            title="Refresh"
            id="RefreshTableButton"
          >
            <ng-container [ngTemplateOutlet]="refreshIcon"></ng-container>
          </button>
        }
        @if (toolbarControls.autoRefresh.show) {
          <span class="lt-autorefresh-wrap" [class.lt-ctl-disabled]="toolbarControls.autoRefresh.disabled">
            <lib-list-table-auto-refresh [loading]="filtering" (refresh)="refresh()"></lib-list-table-auto-refresh>
          </span>
        }
        @if (toolbarControls.columns.show) {
        <div class="lt-columns">
          <button
            type="button"
            class="lt-columns-btn"
            [class.is-on]="hiddenColumnCount > 0"
            [class.is-open]="showColumnChooser"
            (click)="toggleColumnChooser($event)"
            [disabled]="toolbarControls.columns.disabled"
            aria-haspopup="true"
            [attr.aria-expanded]="showColumnChooser"
            id="ColumnChooserButton"
          >
            <svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true">
              <path fill="currentColor" d="M2 3.5h9v1.4H2zM2 7.3h6v1.4H2zM2 11.1h11v1.4H2z"/>
              <circle cx="13" cy="4.2" r="1.7" fill="currentColor"/>
              <circle cx="10" cy="8" r="1.7" fill="currentColor"/>
              <circle cx="14.4" cy="11.8" r="1.7" fill="currentColor"/>
            </svg>
            <span>Columns</span>
            @if (hiddenColumnCount > 0) {
              <span class="lt-columns-count">{{ hiddenColumnCount }}</span>
            }
          </button>
          @if (showColumnChooser) {
            <div class="lt-column-chooser" (clickOutside)="closeColumnChooser()">
              <div class="lt-chooser-header">
                <span class="lt-chooser-title">Columns</span>
                <span class="lt-chooser-subtitle">Customize order and visibility</span>
              </div>
              @if (canSwitchTreeVariant && showTreeVariantToggle) {
                <div class="lt-chooser-view" role="group" aria-label="Expanded row layout">
                  <span class="lt-chooser-view-label">Expanded rows</span>
                  <div class="lt-chooser-view-toggle">
                    <button type="button" class="lt-chooser-view-opt" [class.active]="treeVariant === 'flat'" (click)="setTreeVariant('flat')">Flat</button>
                    <button type="button" class="lt-chooser-view-opt" [class.active]="treeVariant === 'card'" (click)="setTreeVariant('card')">Nested</button>
                  </div>
                </div>
              }
              <div class="lt-chooser-scroll">
              <ul class="lt-chooser-list" cdkDropList cdkDropListLockAxis="y" (cdkDropListDropped)="chooserReorder($event)">
                @for (col of chooserColumns; track col.key) {
                  <li class="lt-chooser-row" cdkDrag cdkDragLockAxis="y" [cdkDragDisabled]="col.reorderable === false"
                      (cdkDragStarted)="onChooserDragStarted()" (cdkDragEnded)="onChooserDragEnded()">
                    <ng-container *ngTemplateOutlet="chooserRowBody; context: { col: col }"></ng-container>
                  </li>
                }
              </ul>
              @if (canSwitchTreeVariant && childLevels.length) {
                <div class="lt-chooser-nested">
                  <button
                    type="button"
                    class="lt-chooser-group"
                    (click)="toggleNestedGroup('__root')"
                    [attr.aria-expanded]="isNestedGroupOpen('__root')"
                  >
                    <span class="lt-chooser-chevron" [class.open]="isNestedGroupOpen('__root')" aria-hidden="true">
                      <svg viewBox="0 0 16 16" width="11" height="11"><path fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" d="M6 4l4 4-4 4"/></svg>
                    </span>
                    <span class="lt-chooser-group-label">Nested rows</span>
                  </button>
                  @if (isNestedGroupOpen('__root')) {
                    @for (level of childLevels; track level) {
                      <button
                        type="button"
                        class="lt-chooser-group lt-chooser-group-sub"
                        (click)="toggleNestedGroup('lvl' + level)"
                        [attr.aria-expanded]="isNestedGroupOpen('lvl' + level)"
                      >
                        <span class="lt-chooser-chevron" [class.open]="isNestedGroupOpen('lvl' + level)" aria-hidden="true">
                          <svg viewBox="0 0 16 16" width="11" height="11"><path fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" d="M6 4l4 4-4 4"/></svg>
                        </span>
                        <span class="lt-chooser-group-label">Level {{ level }}</span>
                        <span class="lt-chooser-group-hint">{{ childLevelLabel(level) }}</span>
                      </button>
                      @if (isNestedGroupOpen('lvl' + level)) {
                        <ul class="lt-chooser-list lt-chooser-sublist" cdkDropList cdkDropListLockAxis="y" (cdkDropListDropped)="chooserReorder($event, level)">
                          @for (col of allColumnsForLevel(level); track col.key) {
                            <li class="lt-chooser-row" cdkDrag cdkDragLockAxis="y" [cdkDragDisabled]="col.reorderable === false"
                                (cdkDragStarted)="onChooserDragStarted()" (cdkDragEnded)="onChooserDragEnded()">
                              <ng-container *ngTemplateOutlet="chooserRowBody; context: { col: col, level: level }"></ng-container>
                            </li>
                          }
                        </ul>
                      }
                    }
                  }
                </div>
              }
              </div>
              <div class="lt-chooser-footer">
                <button
                  type="button"
                  class="lt-chooser-reset"
                  [disabled]="columnsAtDefault"
                  (click)="resetTableColumns()"
                  id="ResetColumnsButton"
                >
                  Reset to default
                </button>
              </div>
            </div>
          }
        </div>
        }
      </div>
    </div>

    <!-- inner content of a Columns-chooser row, shared by the top-level and nested lists.
         The <li cdkDrag> wrapper stays inline in each list (above) so cdkDropList's content
         query still registers it as a draggable; only the body is shared here.
         `level` undefined targets the top-level columns, a number targets that nested depth. -->
    <ng-template #chooserRowBody let-col="col" let-level="level">
      <button
        type="button"
        class="lt-chooser-toggle"
        [class.checked]="!col.hidden"
        [disabled]="col.hideable === false || isLastVisibleColumn(col, level)"
        [attr.title]="isLastVisibleColumn(col, level) ? 'At least one column must stay visible' : null"
        (click)="toggleColumnVisible(col, level)"
        [attr.aria-pressed]="!col.hidden"
      >
        <span class="lt-chooser-box" aria-hidden="true">
          <!-- always rendered: the check is white, so it stays invisible until the box
               turns blue when checked. Keeping it in the DOM means clicking to hide a
               column never detaches the click target, which would otherwise make the
               click-outside handler think the click was outside and close the menu. -->
          <svg viewBox="0 0 12 12" width="10" height="10">
            <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M2 6.3 4.6 9 10 3"/>
          </svg>
        </span>
        <span class="lt-chooser-text">{{ col.label }}</span>
        @if (level == null && isDefaultHidden(col)) {
          <span class="lt-chooser-default-tag">hidden by default</span>
        }
      </button>
      @if (col.reorderable !== false) {
        <!-- the whole row is the drag target (cdkDrag on the <li>); this is just the grip affordance -->
        <span class="lt-chooser-handle" aria-hidden="true">
          <svg viewBox="0 0 10 16" width="10" height="15" fill="currentColor">
            <circle cx="3" cy="3" r="1.25"/><circle cx="7" cy="3" r="1.25"/>
            <circle cx="3" cy="8" r="1.25"/><circle cx="7" cy="8" r="1.25"/>
            <circle cx="3" cy="13" r="1.25"/><circle cx="7" cy="13" r="1.25"/>
          </svg>
        </span>
      }
    </ng-template>

    <div class="lt-scroll" id="ItemTable">
      <!-- expand/collapse control, reused by root rows and nested child rows -->
      <ng-template #treeToggle let-row="row">
        @if (canExpand(row)) {
          <button
            type="button"
            class="lt-tree-toggle"
            [class.is-expanded]="row.__treeExpanded"
            [class.is-loading]="row.__treeLoading"
            [class.is-error]="row.__treeLoadError"
            (click)="$event.stopPropagation(); toggleNode(row)"
            [attr.aria-expanded]="!!row.__treeExpanded"
            [attr.aria-busy]="!!row.__treeLoading"
            [attr.title]="row.__treeLoadError ? 'Could not load children - click to retry' : null"
            [attr.aria-label]="row.__treeExpanded ? 'Collapse row' : 'Expand row'"
          >
            <svg class="lt-tree-chevron" viewBox="0 0 16 16" width="12" height="12" aria-hidden="true">
              <path fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" d="M6 4l4 4-4 4"/>
            </svg>
            @if (row.__treeLoading) {
              <span class="lt-tree-spinner" aria-hidden="true"></span>
            }
          </button>
        } @else {
          <span class="lt-tree-spacer" aria-hidden="true"></span>
        }
      </ng-template>

      <!-- a single cell's content, reused across the fixed grid and the nested grid -->
      <ng-template #cellBody let-col="col" let-row="row" let-i="i">
        @switch (renderMode(col)) {
          @case ('component') {
            <ng-container *ngComponentOutlet="col.cell; inputs: cellInputs(col, row, i)"></ng-container>
          }
          @case ('html') {
            <span class="lt-cell-html" [innerHTML]="cellHtml(col, row, i)"></span>
          }
          @default {
            <span class="lt-cell-text">{{ cellText(col, row, i) }}</span>
          }
        }
      </ng-template>

      <table class="lt-table">
        <colgroup>
          @if (!options.noSelect) { <col class="lt-col-select" /> }
          @for (col of visibleColumns; track trackCol($index, col)) {
            <col [style.width]="colWidth(col)" />
          }
          @if (!options.noMenu) { <col class="lt-col-menu" /> }
        </colgroup>
        <thead class="lt-head">
          <tr cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="onReorder($event)">
            @if (!options.noSelect) {
              <th class="lt-select-cell">
                <div
                  class="lt-select-all"
                  [class.checked]="allToggled"
                  [class.indeterminate]="someSelected"
                  (click)="toggleAll()"
                  id="SelectAllRows"
                ></div>
              </th>
            }
            @for (col of visibleColumns; track trackCol($index, col)) {
              <th
                cdkDrag
                [cdkDragDisabled]="col.reorderable === false"
                class="lt-th"
                [class.lt-th-tree]="isTreeCell(col)"
                [ngClass]="col.cellClass"
                id="Header_{{ col.key }}"
              >
                <lib-list-header-cell
                  [column]="col"
                  [sortDir]="col.sortDir"
                  (sortChanged)="onHeaderSort($event)"
                ></lib-list-header-cell>
                @if (col.resizable !== false) {
                  <span class="lt-resize" (pointerdown)="startResize(col, $event)"></span>
                }
              </th>
            }
            @if (!options.noMenu) {
              <th class="lt-menu-cell">
                <div class="lt-header-menu-trigger" (click)="openHeaderActionMenu($event)" id="ColumnMenuHeader">
                  &#8942;
                </div>
              </th>
            }
          </tr>
        </thead>
        <tbody>
          @for (row of flatRows; track trackRow($index, row); let i = $index) {
            @if (isTreeMode && row.__treeLevel > 0 && hasChildColumns) {
              <!-- nested rows with their own per-level columns, laid out in a grid
                   that spans the full table width (so they need not match the parent) -->
              @if (row.__treeFirstChild) {
                <tr class="lt-tree-subhead-row">
                  <td
                    [attr.colspan]="treeSpanCount"
                    [style.--lt-tree-indent.rem]="treeIndentFor(row.__treeLevel)"
                    [style.--lt-tree-first-indent.rem]="treeFlatFirstIndentRem(row.__treeLevel)"
                    [style.--lt-tree-lead-offset]="treeLeadOffset(row.__treeLevel)"
                    [style.background-image]="treeAncestorRails(row.__treeLevel)"
                  >
                    <div
                      class="lt-tree-grid"
                      [style.grid-template-columns]="gridTemplate(row.__treeLevel)"
                    >
                      @if (childSelectEnabled) {
                        <span class="lt-tree-subhead-cell lt-tree-select-cell"></span>
                      }
                      @for (col of columnsForLevel(row.__treeLevel); track col.key; let last = $last) {
                        <span class="lt-tree-subhead-cell" [class.lt-tree-indent-col]="isTreeColumn(col, row.__treeLevel)" [ngClass]="cellClass(col)">
                          {{ col.label }}
                          @if (!last && col.resizable !== false) {
                            <span class="lt-resize lt-tree-resize" (pointerdown)="startChildResize(col, row.__treeLevel, $event)"></span>
                          }
                        </span>
                      }
                    </div>
                  </td>
                </tr>
              }
              <tr
                class="lt-row lt-tree-child-row"
                [class.lt-tree-last-child]="row.__treeLastChild"
                [class.lt-row-selected]="row.selected || row.open"
                [class.lt-row-expanded]="row.__treeExpanded"
                (mouseenter)="onRowHover(row)"
                (mouseleave)="onRowLeave(row)"
              >
                <td
                  [attr.colspan]="treeSpanCount"
                  [style.--lt-tree-indent.rem]="treeIndentFor(row.__treeLevel)"
                  [style.--lt-tree-first-indent.rem]="treeFlatFirstIndentRem(row.__treeLevel)"
                  [style.--lt-tree-lead-offset]="treeLeadOffset(row.__treeLevel)"
                  [style.background-image]="treeAncestorRails(row.__treeLevel)"
                >
                  <div
                    class="lt-tree-grid"
                    [style.grid-template-columns]="gridTemplate(row.__treeLevel)"
                  >
                    @if (childSelectEnabled) {
                      <div class="lt-tree-cellbox lt-tree-select-cell">
                        <lib-select-cell [row]="row" [toggleItem]="toggleItem"></lib-select-cell>
                      </div>
                    }
                    @for (col of columnsForLevel(row.__treeLevel); track col.key) {
                      <div
                        class="lt-tree-cellbox"
                        [class.lt-tree-indent-col]="isTreeColumn(col, row.__treeLevel)"
                        [ngClass]="cellClass(col)"
                        (click)="onCellClick(col, row, i)"
                        (mouseenter)="onCellHover(col, row, i, $event)"
                        (mouseleave)="onCellLeave()"
                      >
                        @if (isTreeColumn(col, row.__treeLevel) && showTreeLead(row)) {
                          <span class="lt-tree-lead">
                            <ng-container *ngTemplateOutlet="treeToggle; context: {row: row}"></ng-container>
                          </span>
                        }
                        <ng-container *ngTemplateOutlet="cellBody; context: {col: col, row: row, i: i}"></ng-container>
                      </div>
                    }
                  </div>
                </td>
              </tr>
            } @else {
              <tr
                class="lt-row"
                [class.lt-row-odd]="i % 2 === 1"
                [class.lt-row-selected]="row.selected || row.open"
                [class.lt-row-expanded]="row.__treeExpanded"
                [class.row-invalid]="row.invalid"
                [class.row-copied]="row.copied"
                (mouseenter)="onRowHover(row)"
                (mouseleave)="onRowLeave(row)"
              >
                @if (!options.noSelect) {
                  <td class="lt-select-cell">
                    <lib-select-cell [row]="row" [toggleItem]="toggleItem"></lib-select-cell>
                  </td>
                }
                @for (col of visibleColumns; track trackCol($index, col)) {
                  <td
                    class="lt-cell"
                    [class.lt-tree-cell]="isTreeCell(col)"
                    [ngClass]="cellClass(col)"
                    (click)="onCellClick(col, row, i)"
                    (mouseenter)="onCellHover(col, row, i, $event)"
                    (mouseleave)="onCellLeave()"
                  >
                    @if (isTreeCell(col)) {
                      <span class="lt-tree-cell-inner">
                        <span class="lt-tree-lead" [style.margin-left.rem]="(row.__treeLevel || 0) * treeIndentRem">
                          <ng-container *ngTemplateOutlet="treeToggle; context: {row: row}"></ng-container>
                        </span>
                        <ng-container *ngTemplateOutlet="cellBody; context: {col: col, row: row, i: i}"></ng-container>
                      </span>
                    } @else {
                      <ng-container *ngTemplateOutlet="cellBody; context: {col: col, row: row, i: i}"></ng-container>
                    }
                  </td>
                }
                @if (!options.noMenu) {
                  <td class="lt-menu-cell">
                    @if (row.actionList?.length) {
                      <button
                        type="button"
                        class="lt-row-menu-trigger"
                        (click)="$event.stopPropagation(); openActionMenu($event, row)"
                        attr.id="RowMenu_{{ row.id }}"
                        aria-label="Row actions"
                      >&#8942;</button>
                    }
                  </td>
                }
              </tr>
            }
          }
        </tbody>
      </table>
      @if (!isLoading && filterApplied && (!rowData || rowData.length === 0)) {
        <div class="no-rows-message">No Rows To Show</div>
      }
    </div>

    <div class="lt-footer">
      <div class="lt-footer-count">
        Showing <span id="Start">{{ startCount }}</span>&#8211;<span id="End">{{ endCount }}</span>
        of <span id="Total">{{ totalCount }}</span>
      </div>
      <div class="lt-footer-controls">
        @if (toolbarControls.pageSize.show) {
          <div class="lt-rpp" [class.lt-ctl-disabled]="toolbarControls.pageSize.disabled">
            <span class="lt-rpp-label">Rows per page</span>
            <select
              class="lt-rpp-select"
              [disabled]="filtering || toolbarControls.pageSize.disabled"
              [value]="pageSize"
              (change)="onPageSizeChange(+$any($event.target).value)"
              aria-label="Rows per page"
            >
              @for (opt of pageSizeOptions; track opt) {
                <option [value]="opt">{{ opt }}</option>
              }
            </select>
          </div>
        }
        @if (toolbarControls.pagination.show) {
          <div class="lt-pager" [class.lt-ctl-disabled]="toolbarControls.pagination.disabled">
            <button type="button" class="lt-page-btn icon-prev" [disabled]="prevDisabled" (click)="prevPage()" aria-label="Previous page"></button>
            @if (!cursorPager) {
              @for (p of pageWindow; track $index) {
                @if (p === 0) {
                  <span class="lt-page-gap">&#8230;</span>
                } @else {
                  <button
                    type="button"
                    class="lt-page-num"
                    [class.is-current]="p === currentPageNum"
                    (click)="goToPage(p)"
                  >{{ p }}</button>
                }
              }
            }
            <button type="button" class="lt-page-btn icon-next" [disabled]="nextDisabled" (click)="nextPage()" aria-label="Next page"></button>
          </div>
        }
      </div>
    </div>

    <!-- header action menu -->
    <lib-list-menu
      menuId="HeaderActionMenu"
      [open]="openHeaderMenu"
      [items]="headerMenuItems"
      [left]="menuLeft"
      [top]="menuTop"
      (itemClick)="onHeaderMenuClick($event)"
      (closed)="closeHeaderActionMenu()"
    ></lib-list-menu>

    <!-- row action menu -->
    <lib-list-menu
      menuId="RowActionMenu"
      [open]="openMenu"
      [items]="rowMenuItems"
      [left]="menuLeft"
      [top]="menuTop"
      (itemClick)="onRowMenuClick($event)"
      (closed)="closeActionMenu()"
    ></lib-list-menu>
  </div>
} @else {
  <lib-no-items
    (clickEmit)="openCreate()"
    [image]="noItemsImage"
    [isEmpty]="!rowData || rowData.length === 0"
    [isLoading]="isLoading"
    [typeName]="entityTypeLabel"
    [hasAdd]="showNoItemsAdd"
    [readonly]="noItemsReadonly"
    [accessDenied]="accessDenied"
  ></lib-no-items>
}

@if (hoverTooltip) {
  <div class="lt-tooltip" [ngStyle]="{ left: hoverTooltip.left + 'px', top: hoverTooltip.top + 'px' }">
    <ng-container *ngComponentOutlet="hoverTooltip.component; inputs: hoverTooltip.inputs"></ng-container>
  </div>
}
